(function () {
  'use strict';

  /* @ngdoc object
   * @name parcels.list
   * @description
   *
   */
  angular
    .module('parcels.list', [
      'ui.router'
    ]);
}());
